export const FINANCIAL_VERSION = "financialTemplateId";
export const REPORT_EXPANSION = "reportExpansion";
export const SCOPE = "scope";
export const UNIT_DISPLAY = "unitDisplay";
export const RETAINED_EARNING = "retainedEarnings";
export const BUDGET = "budgets";
export const BUDGET_VERSION = "communityBudgetId";
export const DOWNLOAD_REPORT = "downloadReport"
export const OBJECT_TYPE = "objectType";
export const OBJECT_VALUES = "objectValues";
export const REPORTING_LEVEL = "reportLevel";
export const REPORTING_PERIOD = "periodBasis";
export const FISCAL_YEAR = "fiscalYear";
export const PERIOD_FROM = "periodFrom";
export const PERIOD_TO = "periodTo";
export const DOCUMENT_TYPES = "documentTypeIds";
export const GL_MASTERS = "glMasterIds";
export const ACC_CATEGORY = "accountCategoryIds";

export const reportExpansionOptions = [
  {label: "By Sub-Groups", value: "BY_SUB_GROUPS"},
  {label: "By GL Accounts", value: "BY_GL_ACCOUNTS"},
];

export const scopeOptions = [
  {label: "P&L Only (default)", value: "P_AND_L"},
  {label: "P&L and B/S", value: "P_AND_L_BS"},
];

export const unitDisplayOptions = [
  {label: "Report Units (default)", value: "REPORT_UNIT"},
  {label: "Suppress Units", value: "SUPPRESS_UNITS"},
];

export const retainedEarningsOptions = [
  {label: "Without Retained Earnings (default)", value: "WITHOUT"},
  {label: "With Retained Earnings", value: "WITH"},
];

export const downloadReportOptions = [
  {label: "Excel (CSV) (Default)", value: "CSV"},
  {label: "Text (TSV)", value: "TSV"},
];

export const budgetOptions = [
  {label: "With Budgets (Default)", value: "WITH_BUDGET"},
  {label: "Without Budgets", value: "WITHOUT_BUDGET"},
];

export const reportingPeriodOptions = [
  {label: "Entry Year (default)", value: "ENTRY_YEAR"},
  {label: "Budget Year", value: "BUDGET_YEAR"},
];

export const LEVELS = ["COMMUNITY", "ZONE", "BLOCK", "PROPERTY"];
export const LEVEL_LABELS: Record<string, string> = { COMMUNITY: "Community", ZONE: "Zone", BLOCK: "Block", PROPERTY: "Property" };
